$(function() {    
	var CSVArr = $.csv.toArrays($('#CSVstring').text());
	$(document).on('submit','.couponsearch',function(e){
		e.preventDefault();
		if($('.couponquery', this).val() === '') {
			alert('You forgot to enter a coupon code.');
			$('.couponquery', this).focus();
			return false;
		} 
		
		var findCouponOrig = $('.couponquery', this).val();
		var url;
		function runQuery(charLimit) {
			var findCoupon = findCouponOrig.substr(0,charLimit);
			url = $.map(CSVArr, function(CSVArr) {
				if(CSVArr[0].indexOf(findCoupon) === 0) {
					return CSVArr[1];
				}		 
			});
			console.log(charLimit);
			if(url.length === 0) {					
				if(charLimit === 10) {
					runQuery(9);
				}						
				if(charLimit === 9) {
					runQuery(8);
				}					
				if(charLimit === 8) {
					runQuery(7);
				}					
				if(charLimit === 7) {
					runQuery(6);
				}	
				if(charLimit !== 10 && charLimit !== 9 && charLimit !== 8 && charLimit !== 7) {
					alert('Coupon code not found!');
				}
			} else {
				console.log(url[0].toLowerCase());
             // console.log('https://monogramhub2.myshopify.com/discount/'+ findCouponOrig + '?redirect=%2F'+ $.trim(url[0].toLowerCase()));
				window.location.href ='https://monogramhub2.myshopify.com/discount/'+ findCouponOrig + '?redirect=%2Fproducts%2F'+ $.trim(url[0].toLowerCase()) ;
			}
		}
		runQuery(10);
	});
});
